export default [
    {
      path: '/main/checklist',
      meta: {
        tag: 'checklist',
        name: 'Checklist',
        breadcrumb: 'Checklist',
        menu: 'settings'
      },
      component: () => import(/* webpackChunkName: "checklist" */ '@/views/main/settings/consults/checklist/Checklist.vue')
    }
]
